interface IGuidelineSubSection {
  title: string;
  explanation: string;
}

interface IGuidelineSection {
  title: string;
  subSections: IGuidelineSubSection[];
}

export const guidelinesText: IGuidelineSection[] = [
  {
    title: 'Content Standards',
    subSections: [
      {
        title: 'Appropriate Content',
        explanation:
          'Please only upload images that are appropriate for all ages and do not include explicit content such as nudity, violence, or hate speech. Keep it clean and friendly.',
      },
      {
        title: 'Respect for Others',
        explanation:
          'We strive to create a welcoming environment. Do not post images or content that could be offensive or harmful to individuals or groups based on race, ethnicity, religion, gender, sexual orientation, disability, or any other characteristic. Respect the diversity of our community.',
      },
      {
        title: 'Originality and Copyright',
        explanation:
          'Share only your original creations or images for which you have explicit rights. It is critical to respect intellectual property and avoid copyright infringement. Ensure that you have the right to use and share any content you upload. Unauthorised use of copyrighted material is strictly prohibited and will be taken seriously to protect the rights of creators.',
      },
      {
        title: 'Authenticity of Content',
        explanation:
          'We value the authenticity of content. Only upload real, unaltered images. AI-generated images, photo manipulations, or modifications of real places are not permitted. This policy ensures the integrity and truthfulness of the content shared.',
      },
    ],
  },
  {
    title: 'Truthfulness',
    subSections: [
      {
        title: 'Accuracy',
        explanation:
          'Be honest and provide accurate information when creating your account and uploading content. Misrepresentation detracts from the trust and integrity of our community.',
      },
      {
        title: 'No Impersonation',
        explanation:
          'Impersonating others or misrepresenting your identity is not allowed and will be taken seriously.',
      },
    ],
  },
  {
    title: 'Safety',
    subSections: [
      {
        title: 'Personal Information',
        explanation:
          'Avoid sharing personal information through images or any associated metadata to protect your privacy and the privacy of others.',
      },
      {
        title: 'Reporting Mechanisms',
        explanation:
          'If you encounter inappropriate content or behavior, please report it through our reporting tools. We are committed to reviewing reports promptly and taking appropriate actions to maintain community standards.',
      },
    ],
  },
  {
    title: 'Legal Compliance',
    subSections: [
      {
        title: 'Adherence to Laws',
        explanation:
          'You are responsible for ensuring that your content complies with local, national, and international laws, including copyright and privacy laws.',
      },
      {
        title: 'Consequences',
        explanation:
          'Violations of our guidelines may result in the removal of content, suspension, or termination of accounts. We take these actions to protect the integrity of our community.',
      },
    ],
  },
  {
    title: 'Promotion and Advertising',
    subSections: [
      {
        title: 'No Spam',
        explanation:
          'Commercial content should not be spammy or unsolicited. Keep our community free from spam.',
      },
      {
        title: 'No Promotion',
        explanation:
          'Our platform is not a space for commercial activities or advertisements. Please refrain from any form of promotion. This policy helps maintain the focus on creativity and community interaction.',
      },
    ],
  },
  {
    title: 'Engagement',
    subSections: [
      {
        title: 'Encouragement of Positive Interaction',
        explanation:
          "We encourage a positive and supportive environment. Support other users' games, provide constructive feedback, and help us build a community that everyone enjoys.",
      },
      {
        title: 'Community Building',
        explanation:
          'Your contributions are important. Engage in activities that support community building and foster a friendly atmosphere.',
      },
    ],
  },
];
